module.exports = __webpack_public_path__ + "static/zuri-hybrid-vtol-technology-overview-animation-transition-propulsion-d6f2c476b52dc29d9a7fcc07b54d7bc0.mp4";